import React from 'react';
import './styles/theme.css';

function App() {
  return (
    <div className="container" style={{ paddingTop: 48, paddingBottom: 48 }}>
      <div className="card" style={{ padding: 28 }}>
        <h1 style={{ marginTop: 0 }}>Categorizer</h1>
        <p style={{ color: 'var(--color-text-muted)' }}>
          Automatically categorize unstructured data with speed and accuracy.
        </p>
        <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
          <a className="button" href="/login">Log in</a>
          <a className="button secondary" href="/register">Create account</a>
        </div>
      </div>
    </div>
  );
}

export default App;
